export default __webpack_public_path__ + "79b83d4fcbccfcdc0be562a466dea280.svg";